const config = require("./redirects.json");

const sitemapIgnore = { sitemap: { ignoreRoute: true } };

function normalizePath(path) {
  return (path || "/").replace(/\/$/, "").toLowerCase() || "/";
}

function isCaseOnlyChange(from, to) {
  return normalizePath(from) === normalizePath(to);
}

function vueRedirects() {
  const exact = config.exact
    .filter((rule) => !isCaseOnlyChange(rule.source, rule.target))
    .map((rule) => ({
      path: rule.source.replace(/\/$/, "") || "/",
      redirect: rule.target,
      meta: sitemapIgnore,
    }));

  const prefix = config.prefix.flatMap((rule) => {
    const base = rule.source.replace(/\/$/, "");

    return [
      {
        path: base,
        redirect: rule.target,
        meta: sitemapIgnore,
      },
      {
        path: `${base}/:catchAll(.*)`,
        redirect: rule.target,
        meta: sitemapIgnore,
      },
    ];
  });

  return [...exact, ...prefix];
}

module.exports = {
  vueRedirects,
};
